import { AbstractField } from './AbstractField';

export class Field extends AbstractField<string, string> {
    public makeUpdateParams(): string {
        return this.fieldValue;
    }

    protected setFieldValue(value: string): void {
        this.fieldValue = value;
    }
}
